import React from 'react';
import './file.scss';
import PropTypes from 'prop-types';


const FileChosen = ({text,linktext}) => {
  return (
    <div className='file-chosen'>
      <p>{text} {linktext}</p>
    </div>
  );
};

FileChosen.propTypes = {
  text: PropTypes.string,
  linktext: PropTypes.string
};

FileChosen.defaultProps = {
  text: 'File uploaded',
  linktext: ''
}

export default FileChosen;